module.exports = __webpack_public_path__ + "static/img/spring_pipaPic.f6f94e18.png";